import { TextField } from '@hopskipdrive/react-components';
import { Avatar, MenuItem } from '@mui/material';
import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';

export const StyledAssigneeAvatar = styled(Avatar)`
  && {
    width: 33px;
    height: 33px;
    font-size: 14px;

    h6 {
      color: ${colorTokens.text.contrast};
    }

    &.color-1 {
      background-color: ${colorTokens.avatar[1]};
    }
    &.color-2 {
      background-color: ${colorTokens.avatar[2]};
    }
    &.color-3 {
      background-color: ${colorTokens.avatar[3]};
    }
    &.color-4 {
      background-color: ${colorTokens.avatar[4]};
    }
    &.color-5 {
      background-color: ${colorTokens.avatar[5]};
    }
    &.color-6 {
      background-color: ${colorTokens.avatar[6]};
    }
    &.color-7 {
      background-color: ${colorTokens.avatar[7]};
    }
    &.color-8 {
      background-color: ${colorTokens.avatar[8]};
    }
  }
`;

export const AssigneeTextField = styled(TextField)`
  && {
    .MuiAvatar-root {
      margin: -8px 0;
    }

    .Mui-focused .MuiAvatar-root {
      margin: -10px 0;
    }

    &.selected input {
      text-transform: capitalize;
    }
  }
`;

export const AssigneeItem = styled(MenuItem)`
  && {
    margin: 6px 0;

    p {
      text-transform: capitalize;
      margin-left: 12px;
    }
  }
`;
